module.exports = __webpack_public_path__ + "static/media/car_round.1ef44b3f.png";